import MapLayer from '../map-layer.enum';
import setFirstCallLayer from './first-call-layer';

function addFirstCallLayer(layer: MapLayer | string, metadata?: {}) {
  return setFirstCallLayer(layer, metadata);
}

export default addFirstCallLayer;
